import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { RESEND_INVITATION_RESOURCE, PENDING_INVITATIONS_RESOURCE } from '../../constants';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';

const ResendInvitationService = ComposedComponent =>
  reduxFetch([
    {
      resource: RESEND_INVITATION_RESOURCE,
      method: 'PUT',
      request: (id, callback, rejectCallback, t) => ({
        url: apiRoutes.reInvite(id),
        meta: {
          callback,
          rejectCallback,
          updateOtherList: {
            resource: PENDING_INVITATIONS_RESOURCE,
            listPath: 'invitations',
            idProp: 'id',
            id,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'resendInvitationFailed'),
            onSuccessMessage: t('resendInvitationSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default ResendInvitationService;
